import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
import { ControlConstants } from "../constant/ControlConstants";
import { HorizontalLayout } from "../layout/HorizontalLayout";
import { PanelProperties } from "./PanelProperties";
import { ToggleButtonProperties } from "./ToggleButtonProperties";
/**
 * PagingProperties.ts
 */
export class PagingProperties extends AbstractViewProperties {
    constructor(asset, component) {
        super();
        this.asset = asset;
        this.component = component;
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.buttonProperties.equals(other.buttonProperties) &&
            this.panelProperties.equals(other.panelProperties);
    }
    setDefaultValues() {
        this.buttonProperties = new ToggleButtonProperties(this.asset + "PageButton", this.component);
        this.panelProperties = new PanelProperties();
        this.panelProperties.layout = new HorizontalLayout(5, ControlConstants.CENTER);
    }
}
//# sourceMappingURL=PagingProperties.js.map